import { pick } from 'lodash-es'

const transformToCreateMenuScrapingTemplateInput = ({ id, ...data }) => ({
  data: pick(data, ['name', 'scrapingInstructions']),
})

export default transformToCreateMenuScrapingTemplateInput
